import React from 'react';
import PropTypes from 'prop-types';
const StickyFooterToolbar: React.FC<Props> = (props: any) => {
  const { sideRailButtons, buttonWithIcon } = props.stickyFooterButtonsObj;
  return (
    <div
      className="stickyFooterToolbar bx--col-lg-0"
      data-testid="stickyFooterToolbar"
    >
      {sideRailButtons && (
        <div className="map-action--buttons  bx--col-sm-16  bx--col-md-10">
          {sideRailButtons}
        </div>
      )}
      {buttonWithIcon && (
        <div className="inside-button--wrapper bx--col-sm-16  bx--col-md-6">
          {buttonWithIcon}
        </div>
      )}
    </div>
  );
};
const propTypes = {
  stickyFooterButtonsObj: PropTypes.object
};

type Props = PropTypes.InferProps<typeof propTypes>;

StickyFooterToolbar.propTypes = propTypes;

export default StickyFooterToolbar;
